module.exports = __webpack_public_path__ + "img/app-artwork.3b1d18b8.png";